// src/components/EventCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import TemplateMiniPreview from './TemplateMiniPreview';
import { IconEye, IconEdit, IconTrash, IconCalendar } from './ui/Icons';

const STATUS_STYLES = {
  DRAFT:     { label: 'Borrador',  color: 'bg-slate-100 text-slate-600' },
  ACTIVE:    { label: 'Activo',    color: 'bg-green-100 text-green-700' },
  EXPIRED:   { label: 'Expirado',  color: 'bg-red-100 text-red-700' },
  SUSPENDED: { label: 'Suspendido', color: 'bg-yellow-100 text-yellow-700' },
  DELETED:   { label: 'Eliminado', color: 'bg-slate-100 text-slate-400' },
};

export default function EventCard({ event, onDelete }) {
  const status = STATUS_STYLES[event.status] || STATUS_STYLES.DRAFT;
  const publicUrl = `${process.env.REACT_APP_PUBLIC_URL}/i/${event.shortCode}`;
  const isActive = event.status === 'ACTIVE';

  return (
    <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden hover:shadow-lg transition flex flex-col">
      {/* Mini preview con datos REALES del evento */}
      <Link to={`/events/${event.id}`} className="block">
        <div className="aspect-[4/3] relative overflow-hidden">
          <TemplateMiniPreview
            slug={event.template?.slug}
            category={event.template?.category}
            data={event.data}
            size="sm"
          />

          {/* Badge de estado */}
          <span
            className={`absolute top-3 right-3 text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wide ${status.color}`}
          >
            {status.label}
          </span>
        </div>
      </Link>

      <div className="p-4 flex-1 flex flex-col">
        {/* Título */}
        <h3 className="font-bold text-slate-800 line-clamp-2 leading-snug">
          {event.title}
        </h3>

        {/* Meta info */}
        <div className="mt-2 space-y-1.5 text-xs text-slate-500">
          <div className="flex items-center gap-1.5">
            <span className="w-3.5 h-3.5 opacity-70">
              <IconCalendar className="w-full h-full" />
            </span>
            <span>
              {event.template?.name}
              {event.expiresAt && (
                <> · Expira {new Date(event.expiresAt).toLocaleDateString('es-PE', {
                  day: '2-digit', month: 'short',
                })}</>
              )}
            </span>
          </div>
        </div>

        {/* Acciones */}
        <div className="mt-4 pt-3 border-t border-slate-100 flex items-center justify-between gap-1">
          <Link
            to={`/events/${event.id}`}
            className="flex-1 flex items-center justify-center gap-1.5 text-xs font-semibold text-slate-700 bg-slate-100 hover:bg-slate-200 py-2 rounded-lg transition"
          >
            <span className="w-3.5 h-3.5">
              <IconEdit className="w-full h-full" />
            </span>
            Administrar
          </Link>

          {isActive && (
            <a
              href={publicUrl}
              target="_blank"
              rel="noreferrer"
              title="Ver invitación"
              className="p-2 rounded-lg text-slate-500 hover:text-brand-600 hover:bg-brand-50 transition"
            >
              <span className="w-4 h-4 block">
                <IconEye className="w-full h-full" />
              </span>
            </a>
          )}

          <button
            onClick={onDelete}
            title="Eliminar"
            className="p-2 rounded-lg text-slate-400 hover:text-red-600 hover:bg-red-50 transition"
          >
            <span className="w-4 h-4 block">
              <IconTrash className="w-full h-full" />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}